export default __webpack_public_path__ + "static/desk03-4916bb9a80208e429cbe2ad478010f1f.png";